import SignUp3Container from "../../../components/pages/other/SignUp3";

const SignUp3 = () => {
  return <SignUp3Container />;
};

export default SignUp3;
